import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslatePipe} from '@brunata-angular/util';
import {SelectBuildingTableComponent} from 'src/app/select-building/select-building-table/select-building-table.component';
import {DateTime} from 'luxon';
import {Store} from '@ngrx/store';
import {selectUser} from 'src/app/state/selectors';
import {filter, map} from 'rxjs';
import {UserStateSuccess} from 'src/app/state/reducers';
import {ActivatedRoute, Router} from '@angular/router';
import {User} from '@shared/services/user.service';

@Component({
    selector: 'app-termination-of-contract',
    standalone: true,
    imports: [CommonModule, TranslatePipe, SelectBuildingTableComponent],
    template: ` <div class="container-fluid my-3">
        @if (user$ | async; as user) {
            <h3>{{ 'actions_cancelSystem' | translate: 'online' : 'common' }}</h3>
            <p>{{ 'common_termination_of_contract_text' | translate }}</p>
            <app-select-building-table (loadBuilding)="selectBuilding($event, user)" />
        }
    </div>`,
    styles: ``,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TerminationOfContractComponent {
    private readonly store = inject(Store);
    private readonly router = inject(Router);
    private readonly activatedRoute = inject(ActivatedRoute);

    readonly user$ = this.store.select(selectUser).pipe(
        filter((userState): userState is UserStateSuccess => userState.status === 'success'),
        map(userState => userState.user),
    );

    selectBuilding(building: {buildingNo: string}, user: User): void {
        const uniqueId = DateTime.now()
            .toLocaleString(DateTime.DATE_SHORT, {locale: 'da'})
            .concat(`${building.buildingNo}`, `${user.debtorNo}`);
        const url = `https://brunata.dk/opsigelsesformular?buildingNo=${building.buildingNo}&debtorNo=${user.debtorNo}&timestamp=${new Date().toString()}&id=${uniqueId}`;
        window.open(url, '_blank');
        void this.router.navigate(['.'], {relativeTo: this.activatedRoute.root});
    }
}
